import type { LeaderboardPageData } from '@/features/leaderboard/usePagedLeaderboard'
import { apiRequest } from '@/shared/api/client'

import { entryToRow } from './adapters'
import type { ClubLeaderboardRow, ClubsLeaderboardScope } from './types'
import type {
  ClubsLeaderboardApiPage,
  ClubsLeaderboardApiPosition
} from './types-api'

export async function fetchClubsLeaderboardPage(
  scope: ClubsLeaderboardScope,
  page: number,
  pageSize: number,
  /** The page's language: the club's sport comes localized (BAT-860). */
  lang?: string
): Promise<LeaderboardPageData<ClubLeaderboardRow>> {
  const response = await apiRequest<Partial<ClubsLeaderboardApiPage>>({
    path: '/api/v2/leaderboards/clubs',
    method: 'GET',
    query: {
      ...(scope.sportType ? { sport_type: scope.sportType } : {}),
      ...(scope.search ? { search: scope.search } : {}),
      page,
      page_size: pageSize
    },
    ...(lang ? { headers: { Lang: lang } } : {}),
    format: 'json'
  })

  return {
    rows: (response.entries ?? []).map(entry => entryToRow(entry)),
    total: response.total_count ?? 0
  }
}

/**
 * The club's rank on the World board. `null` when the gateway does not serve
 * the position route yet — the caller then falls back to the club profile.
 */
export async function fetchClubsLeaderboardPosition(
  clubId: string,
  sportType?: string
): Promise<ClubsLeaderboardApiPosition | null> {
  try {
    return await apiRequest<ClubsLeaderboardApiPosition>({
      path: '/api/v2/leaderboards/clubs/position',
      method: 'GET',
      query: {
        club_id: clubId,
        ...(sportType ? { sport_type: sportType } : {})
      },
      format: 'json'
    })
  } catch {
    return null
  }
}
